<template>
  <base-layout>
    <template v-slot:header>
      <router-view></router-view>
      <h1 class="text-3xl font-bold leading-tight text-gray-900">
        Promocija
      </h1>
      <div class="flex items-center text-sm text-gray-500" v-if="promotion.activePromotion && promotion.activePromotion.location">
        <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        <p>
          {{ promotion.activePromotion.location }}
        </p>
        <svg class="flex-shrink-0 mx-1.5 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd" />
        </svg>
        <p>
          <time datetime="2021-09-09T10:00:00.000" v-html="promotion.activePromotion.date"></time>
        </p>
      </div>

    </template>
    <template v-slot:default v-if="promotion.dataHasBeenLoaded">
      <div class="bg-white shadow overflow-hidden sm:rounded-md" v-if="!promotion.activePromotion">
        <ul class="divide-y divide-gray-200">
          <li>
            <router-link to="/promotion/new-promotion" class="block hover:bg-gray-50">
              <div class="flex items-center px-4 py-4">
                <div class="min-w-0 flex-1 flex items-center">
                  <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                    <div>
                      <p class="text-lg font-medium text-indigo-600 truncate">Pokretanje nove promocije</p>
                      <p class="mt-2 flex items-center text-sm text-gray-500">
                        Link za demonostraciju pokretanja nove promocije.
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <!-- Heroicon name: solid/chevron-right -->
                  <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                  </svg>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>

      <div v-else>

        <div class="bg-white shadow overflow-hidden sm:rounded-md">
          <ul class="divide-y divide-gray-200">
            <li>
              <router-link :to="`/promotion/edit-promotion/${promotion.activePromotion.type.name}`" class="block hover:bg-gray-50">
                <div class="flex items-center px-4 py-4">
                  <div class="min-w-0 flex-1 flex items-center">
                    <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                      <div>
                        <p class="text-lg font-medium text-indigo-600 truncate">Osnovne informacije</p>
                        <p class="mt-2 flex items-center text-sm text-gray-500">
                          Izmenite osnovne informacije o promociji.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <!-- Heroicon name: solid/chevron-right -->
                    <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>

      <div class="space-y-8 divide-y divide-gray-200 sm:space-y-5 mb-5 mt-10">
        <div>
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Provera lagera
            </h3>
            <p class="mt-1 max-w-4xl text-sm text-gray-500">
              Preporučeno je da se lager proveri pre početka promocije. Moguće je vršiti i naknadne korekcije tokom trajanje promocije.
            </p>
          </div>
        </div>
      </div>

      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul class="divide-y divide-gray-200">
          <li>
            <router-link to="/promotion/product-count" class="block hover:bg-gray-50">
              <div class="flex items-center px-4 py-4">
                <div class="min-w-0 flex-1 flex items-center">
                  <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                    <div>
                      <p class="text-lg font-medium text-indigo-600 truncate">Stanje preparata</p>
                      <p class="mt-2 flex items-center text-sm text-gray-500" v-if="promotion.activePromotion.products_stock_completed">
                        <!-- Heroicon name: solid/check-circle -->
                          <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                          </svg>
                          Popis je završen.
                      </p>
                      <p class="mt-2 flex items-center text-sm text-gray-500" v-else>
                        Izmenite zatečeno stanje kod preparata gde je to potrebno
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <!-- Heroicon name: solid/chevron-right -->
                  <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                  </svg>
                </div>
              </div>
            </router-link>
          </li>
          <li v-if="promotion.activePromotion && promotion.activePromotion.type.id !== 3">
            <router-link to="/promotion/gift-count" class="block hover:bg-gray-50">
              <div class="flex items-center px-4 py-4">
                <div class="min-w-0 flex-1 flex items-center">
                  <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                    <div>
                      <p class="text-lg font-medium text-indigo-600 truncate">Stanje poklona</p>
                      <p class="mt-2 flex items-center text-sm text-gray-500" v-if="!promotion.activePromotion.gifts_stock_completed">
                          Izmenite zatečeno stanje kod poklona gde je to potrebno
                      </p>
                      <p class="mt-2 flex items-center text-sm text-gray-500" v-else>
                        <!-- Heroicon name: solid/check-circle -->
                        <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                        </svg>
                        Popis je završen.
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <!-- Heroicon name: solid/chevron-right -->
                  <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                  </svg>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="space-y-8 divide-y divide-gray-200 sm:space-y-5 mb-5 mt-10">
        <div>
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Promocija
            </h3>
            <p class="mt-1 max-w-4xl text-sm text-gray-500">
              Tokom trajanja promocije vrši se prodaja preparata i/ili deljenje poklona.
            </p>
          </div>
        </div>
      </div>

      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul class="divide-y divide-gray-200">
          <li>
            <router-link to="/promotion/product-sales" class="block hover:bg-gray-50">
              <div class="flex items-center px-4 py-4">
                <div class="min-w-0 flex-1 flex items-center">
                  <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                    <div>
                      <p class="text-lg font-medium text-indigo-600 truncate">Preparati</p>
                      <p class="mt-2 flex items-center text-sm text-gray-500">
                        Evidentiranje prodaje preparata.
                      </p>
                      <p class="mt-2 flex items-center text-sm text-gray-500">Prodaja: {{ promotion.activePromotion.products_total_sales }}/{{ promotion.activePromotion.products_target }}</p>
                    </div>
                  </div>
                </div>
                <div>
                  <!-- Heroicon name: solid/chevron-right -->
                  <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                  </svg>
                </div>
              </div>
            </router-link>
          </li>
          <li v-if="promotion.activePromotion && promotion.activePromotion.type.id !== 3">
            <router-link to="/promotion/gift-sales" class="block hover:bg-gray-50">
              <div class="flex items-center px-4 py-4">
                <div class="min-w-0 flex-1 flex items-center">
                  <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                    <div>
                      <p class="text-lg font-medium text-indigo-600 truncate">Pokloni</p>
                      <p class="mt-2 flex items-center text-sm text-gray-500">
                        Evidentiranje podele poklona.
                      </p>
                      <p class="mt-2 flex items-center text-sm text-gray-500">Poklonjeno: {{ promotion.activePromotion.gifts_total_sales }}</p>
                    </div>
                  </div>
                </div>
                <div>
                  <!-- Heroicon name: solid/chevron-right -->
                  <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                  </svg>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="space-y-8 divide-y divide-gray-200 sm:space-y-5 mb-5 mt-10"
           v-if="promotion.activePromotion.type.id === 3"
      >
        <div>
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Nakon završetka promocije
            </h3>
            <p class="mt-1 max-w-4xl text-sm text-gray-500">
              Nakon završetka promocije potrebno je popuniti zadati formular i poslati izveštaj.
            </p>
          </div>
        </div>
      </div>

        <div class="space-y-8 divide-y divide-gray-200 sm:space-y-5 mb-5 mt-10"
             v-if="promotion.activePromotion.type.id !== 3"
        >
          <div>
            <div>
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Završetak promocije
              </h3>
              <p class="mt-1 max-w-4xl text-sm text-gray-500">
                Nakon završetka promocije potrebno je popuniti zadati formular i poslati izveštaj.
              </p>
            </div>
          </div>
        </div>

        <div class="bg-white shadow overflow-hidden sm:rounded-md" v-if="promotion.activePromotion.type.id === 3">
          <ul class="divide-y divide-gray-200">
            <li>
              <router-link :to="endPromotionLink" class="block hover:bg-gray-50">
                <div class="flex items-center px-4 py-4">
                  <div class="min-w-0 flex-1 flex items-center">
                    <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                      <div>
                        <p class="text-lg font-medium text-indigo-600 truncate">Slanje izveštaja</p>
                        <p class="mt-2 flex items-center text-sm text-gray-500">
                          Pokretanje procedure završetka promocije.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <!-- Heroicon name: solid/chevron-right -->
                    <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>

      <div class="bg-white shadow overflow-hidden sm:rounded-md"
           v-if="promotion.activePromotion.type.id !== 3"
      >
        <ul class="divide-y divide-gray-200">
          <li>
            <router-link :to="endPromotionLink" class="block hover:bg-gray-50">
              <div class="flex items-center px-4 py-4">
                <div class="min-w-0 flex-1 flex items-center">
                  <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                    <div>
                      <p class="text-lg font-medium text-indigo-600 truncate">Slanje izveštaja</p>
                      <p class="mt-2 flex items-center text-sm text-gray-500">
                        Pokretanje procedure završetka promocije.
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <!-- Heroicon name: solid/chevron-right -->
                  <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                  </svg>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>

      </div>

    </template>
  </base-layout>
</template>

<script>
import Promotion from './Promotion';
export default Promotion;
</script>
